import { getI18nLanguageStorage } from "shared/storageUtils";
import { Locales } from "./constants";
import { useTranslations } from "./useTranslations";

export function useSyncCurrentLanguage() {
  const { getCurrentLanguage, handleChangeLanguage } = useTranslations();

  const syncCurrentAndStoredLanguage = async () => {
    const storedLanguage = getI18nLanguageStorage();
    const currentLanguage = getCurrentLanguage()?.locale;

    if (storedLanguage == null && currentLanguage == null) {
      return;
    }

    if (storedLanguage == null && currentLanguage != null) {
      handleChangeLanguage(currentLanguage);
      return;
    }

    if (storedLanguage !== currentLanguage) {
      handleChangeLanguage(storedLanguage as Locales);
    }
  };

  return { syncCurrentAndStoredLanguage };
}
